import { fetch } from '@utils/utils';
import * as T from '@modules/hr-shift-cycles/_shiftCyclesTypes';

const getShiftCycle = ({ addError }) => async (id: string): Promise<T.ShiftCycle | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/shift/cycle/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.ShiftCycle = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getShiftCycle };



// WEBPACK FOOTER //
// ./src/modules/hr-shift-cycles/_shiftCyclesActions.ts